import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import dompurify from "isomorphic-dompurify";
import "./ProductMultipacks.scss";
const { sanitize } = dompurify;
export const ProductMultiPacksItem = ({ item }) => {
    if (!item) {
        return _jsx(React.Fragment, {});
    }
    return (_jsx("li", { className: "product-multipacks__list-item", children: _jsxs("a", { className: "product-multipacks__list-link", href: item.pdpUrl ? item.pdpUrl : "#", children: [_jsx("div", { className: "product-multipacks__list-item-title", children: _jsx("span", { children: item.name }) }), item.shortDescription && (_jsx("div", { className: "product-multipacks__list-item-description", dangerouslySetInnerHTML: { __html: sanitize(item.shortDescription) } }))] }) }, item.sku));
};
//# sourceMappingURL=ProductMultipacksItem.js.map